import { LeadType } from "../DataTypes/leads"

// A lead carries two possible email addresses (decision_maker_email,
// company_email) — anywhere a send needs one, offer the choice the same way
// instead of silently picking one.
export type RecipientMode = 'decision_maker' | 'company' | 'both_together' | 'both_separate'

export const RECIPIENT_MODE_OPTIONS: [RecipientMode, string][] = [
    ['decision_maker', 'Decision maker'],
    ['company', 'Company'],
    ['both_together', 'Both (combined)'],
    ['both_separate', 'Both (separate)'],
]

// Returns the address(es) a send should actually go to for a given lead +
// mode. Every mode except 'both_separate' resolves to a single entry (for
// 'both_together' that entry is a comma-joined "a@x.com, b@x.com" — one
// email, two recipients). 'both_separate' resolves to two entries, meaning
// two distinct sendEmail() calls — each recipient only ever sees their own
// address in the To: header, not the other person's.
export const getResolvedRecipients = (lead: LeadType, mode: RecipientMode): string[] => {
    const company = lead.company_email || ''
    const decisionMaker = lead.decision_maker_email || ''
    switch (mode) {
        case 'company': return company ? [company] : []
        case 'decision_maker': return decisionMaker ? [decisionMaker] : []
        case 'both_together': return (company && decisionMaker) ? [`${decisionMaker}, ${company}`] : []
        case 'both_separate': return [decisionMaker, company].filter(Boolean)
    }
}

export const getDefaultRecipientMode = (lead: LeadType): RecipientMode => {
    if (lead.decision_maker_email) return 'decision_maker'
    if (lead.company_email) return 'company'
    return 'decision_maker'
}

// Folds the actual address(es) into the option text itself (e.g.
// "Decision maker — jane@acme.com") instead of surfacing them in a
// separate line below the select.
export const getRecipientOptionLabel = (lead: LeadType, mode: RecipientMode, baseLabel: string): string => {
    const recipients = getResolvedRecipients(lead, mode)
    return recipients.length ? `${baseLabel} — ${recipients.join(', ')}` : `${baseLabel} — no email on file`
}
